/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgradeplan1Inputs */

const en_upgradeplan1 = /** @type {(inputs: Upgradeplan1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade Plan`)
};

const de_upgradeplan1 = /** @type {(inputs: Upgradeplan1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan wechseln`)
};

/**
* | output |
* | --- |
* | "Upgrade Plan" |
*
* @param {Upgradeplan1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const upgradeplan1 = /** @type {((inputs?: Upgradeplan1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgradeplan1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgradeplan1(inputs)
	return de_upgradeplan1(inputs)
});
export { upgradeplan1 as "upgradePlan" }